<h1 class="larfTitle">Welcome to Livearf Employee Login to View Component History</h1>
<div class="container mt-4">
  <h2 class="mb-4">Component History Operations</h2>
  
  <!-- Operations & Table View: Hidden when viewing component details -->
  <div *ngIf="parsedComponents.length === 0">
    <div style="display: flex; align-items: center; gap: 10px;">
      <h4 class="mb-4" style="margin: 0;">How to get Shopify domain from client stores?</h4>
      <div class="info-icon" style="position: relative; display: inline-block; cursor: pointer;">
        ℹ️<span class="info-content">
          <p style="margin: 10px 0 0;"><strong>Example to get Shopify domain</strong></p>
          <br>
          <img src="https://cdn.shopify.com/s/files/1/0675/6646/9345/files/getShop.png?v=1736177437"
            alt="Reference to get shop domain" style="max-width: 100%; max-height: 100%; object-fit: contain;"> 
        </span>
      </div>
    </div>
    <ul>
      <li class="letter-spacing">Go to clients shopify webpage and open console.</li>
      <li>Type Shopify.shop and press enter, then copy paste shop domain in corresponding input field.</li>
    </ul>
    <br>

    <!-- GET Component History UI -->
    <div class="mb-3">
      <label for="getShopDomain">Enter Shopify Domain:</label>
      <input
        type="text"
        id="getShopDomain"
        [(ngModel)]="shopifyDomain"
        class="form-control mb-2"
        placeholder="Enter Shopify Domain"
        (keyup.enter)="fetchHistory()"
      />
      <button class="btn btn-primary" [disabled]="isLoading" (click)="fetchHistory()">
        {{ isLoading ? 'Fetching...' : 'Fetch Components' }}
      </button>
      <p *ngIf="responseMessage" class="mt-2 text-info">{{ responseMessage }}</p>
      <p *ngIf="isLoading" class="mt-2 text-muted">Please wait... Getting latest component history...</p>
    </div>

    <!-- History Records Table -->
    <div *ngIf="responseData.length > 0" class="mt-3">
      <div class="table-responsive">
        <table class="table table-striped table-hover table-bordered align-middle shadow-sm">
          <thead class="table-dark">
            <tr>
              <th class="text-center">Version</th>
              <th class="text-center">Domain</th>
              <th class="text-center">Saved At</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of responseData">
              <td class="text-center">Version {{ item.versionNumber }}</td>
              <td class="text-center">{{ item.domain }}</td>
              <td class="text-center">{{ item.createdAt | date: 'medium' }}</td>
              <td class="text-center">
                <button class="btn btn-info btn-sm" (click)="viewRecordData(item)">
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Component Data Details View: Shown when a version is selected -->
  <div *ngIf="parsedComponents.length > 0" class="mt-3 p-3 border rounded shadow-sm" style="background: #ffffff;">
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
      <h4 style="margin: 0;">Component Data <span *ngIf="selectedVersion">(Version {{ selectedVersion }})</span>:</h4>
      <button class="btn btn-sm btn-secondary" (click)="closePreview()">Close Preview</button>
    </div>

    <!-- Each component has a native arrow to minimize or expand -->
    <details *ngFor="let comp of parsedComponents; let i = index" class="mb-2 border rounded p-2" open>
      <summary style="cursor: pointer; font-weight: bold; font-family: monospace; font-size: 0.95rem; user-select: none;">
        [{{ i }}] {{ comp.component_name || comp.name || 'Component ' + (i + 1) }}
      </summary>
      <pre class="json-preview mt-2 mb-0" style="max-height: 350px;"><code>{{ comp.raw ? comp.raw : (comp | json) }}</code></pre>
    </details>
  </div>

  <br>
  <br>
  <!-- Back to Homepage Button -->
  <div style="margin-bottom: 20px;">
    <button class="btn btn-secondary larfButton" (click)="reloadHome()">Back to Homepage</button>
  </div>
</div>
